import { render, staticRenderFns } from "./BigWheel.vue?vue&type=template&id=7948db90"
import script from "./BigWheel.vue?vue&type=script&lang=js"
export * from "./BigWheel.vue?vue&type=script&lang=js"
import style0 from "./BigWheel.vue?vue&type=style&index=0&id=7948db90&prod&lang=scss&less=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports